import React, { useEffect, useState } from 'react';
import { getPersonalizedMessages } from '../../utility/personalizedMessages';
import { Col, Row, CaptionText } from '@paypalcorp/pp-react';
import { PPGF_DISCLAIMER_TOUCHPOINT } from '../../utility/constants';
import getContent from 'pp-react-l10n';

export default function Disclaimer() {
  const [content, setContent] = useState(null);

  useEffect(() => {
    const touchpoint = getPersonalizedMessages(PPGF_DISCLAIMER_TOUCHPOINT);
    if (!touchpoint || !touchpoint.messages) {
      return;
    }
    const messages = [];
    touchpoint.messages.forEach((message) => {
      if (message.content?.json) {
        Object.keys(message.content.json)
          .sort()
          .forEach((key) =>
            messages.push(
              getContent(
                `personalized.${PPGF_DISCLAIMER_TOUCHPOINT}.${key}`,
                null,
                { useHTML: true }
              ),
              ' '
            )
          );
      }
    });
    setContent(messages);
  }, []);

  if (!content) {
    return null;
  }
  return (
    <Row
      style={{
        maxWidth: '375px',
        marginLeft: 'auto',
        marginRight: 'auto',
      }}
    >
      <Col sm={12}>
        <CaptionText className="legal-text" size="sm">
          {content}
        </CaptionText>
      </Col>
    </Row>
  );
}
